module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1051-4f3dad24bd0ec5052f68df5fc14f4f4d.png";